import { get } from 'lodash';
import { TOKEN_STORAGE_NAME } from '../../screens/Login/actions';

const userNameField = 'sub';

// every reducer should implement it
export const clearState = () => ({
  type: 'CLEAR_STATE',
});

export const clearStorageMiddleware = (store) => (next) => (action) => {
  if (action.type === 'LOGIN_SUCCESS') {
    const state = store.getState();

    if (get(action.user, userNameField) !== get(state.login.user, userNameField)) {
      store.dispatch(clearState());
    }
    localStorage.setItem(TOKEN_STORAGE_NAME, action.token);
  }

  return next(action);
};
